export default {
  color: [
    "#E3EBFD",
    "#E7DCFC",
    "#E0C7EE",
    "#F8D5F8",
    "#E0E0F3",
    "#D4D2F2",
    "#DBCDE3",
    "#E5D0E2",
    "#F5E8F7",
    "#FAE0D8",
    "#F0F4BF",
    "#DFE1BE",
    "#F1DEEE",
    "#FADCDC",
    "#F3EBD2",
    "#E5F9FE",
    "#FFE2D1",
    "#F3D6CE",
    "#FCEE9E",
    "#F6C6C7",
    "#92CEA8",
    "#8BD2EC",
    "#FCF6BD",
    "#D0F4DE",
    "#C0E4F6",
    "#FFBBDA",
    "#E8CFF8",
    "#A8D1E7",
    "#B3DBD8",
    "#FEE5E0",
    "#FFBFC5",
    "#EEE4E1",
    "#E7D8C9",
    "#E6BEAE",
    "#B2967D",
    "#B5B1C8",
    "#F8E8D3",
    "#E8ABB5",
    "#FBCCC2",
    "#695A5B",
    "#CFCAC7",
    "#DFC2C3",
    "#E4D5E3",
    "#BFCED6",
    "#D9E1E2",
    "#ECDBC9",
    "#F898A4",
    "#ADD495",
    "#80B7A2",
    "#F0E4D7",
    "#F3D8D1",
    "#CED6D0",
    "#C7BBBC",
    "#D2DBD6",
    "#B5A3A1",
    "#656C5C",
    "#2E3136",
    "#DEE2EB",
    "#DBCEC5",
    "#9A9E8D",
    "#577460",
    "#E6C2BF",
    "#EED6D3",
    "#928880",
    "#2A505A",
    "#75464A",
    "#AA7C7A",
    "#BEABA7",
    "#CDC6BC",
    "#787A79",
    "#464543",
    "#AF9F8C",
    "#7F867B",
    "#C7C7BB",
    "#D4C8BE",
    "#293242",
    "#9DA2AE",
    "#A4A3A1",
    "#916848",
    "#B3A188",
  ],
};